<!-- advance search start -->
<app-admin-header
  [showBreadCrums]="false"
  header="{{ 'advanced search' | translator }}"
></app-admin-header>

<p-messages [(value)]="messages" [enableService]="false"></p-messages>

<div *ngIf="skelition" style="width: 100%; height: 70vh" class="d-center">
  <p-progressSpinner
    styleClass="w-4rem h-4rem"
    strokeWidth="4"
    fill="var(--surface-ground)"
    animationDuration="1s"
  ></p-progressSpinner>
</div>

<section class="v4-bg-img" *ngIf="!skelition">
  <div class="container-fluid mb-5 pb-2 w-100">
    <div class="search-max-width">
      <div class="d-flex justify-content-between my-2">
        <div>
          <span class="search-heading">
            {{ "Search Within" | translator }}
          </span>
        </div>
        <!-- <div>
                    <span class="search-heading-bold">للقيام بذلك في مربع البحث.</span>
                </div> -->
      </div>

      <div class="web-mob-flex">
        <div class="search-label-box-alignment">
          <label class="search-label">
            {{ "All these words" | translator }}

            &nbsp;:&nbsp;</label
          >
        </div>
        <div class="search-input-box-alignment">
          <input
            name="likeAll"
            [(ngModel)]="extras.likeAll"
            class="search-input ms-input-view"
            type="text"
            pInputText
          />
        </div>
        <div class="">
          <span class="search-details">
            {{ "It contains all these words" | translator }}
          </span>
        </div>
      </div>

      <div class="web-mob-flex">
        <div class="search-label-box-alignment">
          <label class="search-label">
            {{ "This whole word or phrase" | translator }}

            &nbsp;:&nbsp;</label
          >
        </div>
        <div class="search-input-box-alignment">
          <input
            name="sameWord"
            [(ngModel)]="extras.sameWord"
            class="search-input ms-input-view"
            type="text"
            pInputText
          />
        </div>
        <div class="">
          <span class="search-details">
            {{ "Exactly matches this word or phrase" | translator }}
          </span>
        </div>
      </div>

      <div class="web-mob-flex">
        <div class="search-label-box-alignment">
          <label class="search-label">
            {{ "Any of these words:" | translator }}

            &nbsp;:&nbsp;</label
          >
        </div>
        <div class="search-input-box-alignment">
          <input
            name="likeAny"
            [(ngModel)]="extras.likeAny"
            class="search-input ms-input-view"
            type="text"
            pInputText
          />
        </div>
        <div class="">
          <span class="search-details">
            {{ "Includes any of these words" | translator }}
          </span>
        </div>
      </div>

      <div class="web-mob-flex">
        <div class="search-label-box-alignment">
          <label class="search-label">
            {{ "None of these words" | translator }}

            &nbsp;:&nbsp;</label
          >
        </div>
        <div class="search-input-box-alignment">
          <input
            name="notContains"
            [(ngModel)]="extras.notContains"
            class="search-input ms-input-view"
            type="text"
            pInputText
          />
        </div>
        <div class="">
          <span class="search-details">
            {{ "Exclude these words from the search" | translator }}
          </span>
        </div>
      </div>
      <hr class="my-3 v4-border" />

      <!-- dropdown section start -->

      <div class="d-flex justify-content-start my-2">
        <div>
          <span class="search-heading">
            {{ "Narrow your results by..." | translator }}
          </span>
        </div>
      </div>

      <div class="web-mob-flex">
        <div class="search-label-box-alignment">
          <label class="search-label">
            {{ "Data type" | translator }}

            &nbsp;:&nbsp;</label
          >
        </div>
        <div class="search-input-box-alignment">
          <p-dropdown
            [filter]="true"
            filterBy="name"
            [(ngModel)]="extras.type"
            (onChange)="setDropdownFilter($event, 'type')"
            placeholder="{{ 'Select type' | translator }}"
            [options]="dataTypes"
            styleClass="w-100"
            optionLabel="arabic"
            optionValue="_id"
          ></p-dropdown>
        </div>
        <div class="">
          <span class="search-details">
            {{ "Select a type to narrow your search results" | translator }}
          </span>
        </div>
      </div>
      <div class="web-mob-flex" [id]="'Login'" *ngIf="isLoggedIn">
        <div class="search-label-box-alignment">
          <label class="search-label">
            {{ "The side" | translator }}

            &nbsp;:&nbsp;</label
          >
        </div>
        <div class="search-input-box-alignment">
          <p-treeSelect
            appendTo="body"
            class="w-md-20rem w-100"
            containerStyleClass="w-100"
            (onNodeSelect)="setDropdownFilter($event, 'ou')"
            [options]="ous"
            [(ngModel)]="extras.ou"
            placeholder="حدد الجهة"
            [filter]="true"
            [filterInputAutoFocus]="true"
          >
            <ng-template let-node pTemplate="default">
              <div class="d-flex">
                <img
                  *ngIf="checkisImg(node.data); else elseBlock"
                  src="{{ staticFileUrl }} {{ node.data }}"
                  class="img-fluid p-1 tree-img-bg"
                  style="max-height: 30px; max-width: 30px"
                />
                <ng-template #elseBlock>
                  <i class="{{ node.data }} p-2" style="font-size: 1rem"></i>
                </ng-template>
                <b class="text-nowrap">{{ node.label }}</b>
              </div>
            </ng-template>
          </p-treeSelect>
        </div>
        <div class="">
          <span class="search-details">
            {{
              "Select a destination to narrow your search results" | translator
            }}
          </span>
        </div>
      </div>

      <hr class="v4-border" />

      <div class="d-flex justify-content-start my-2">
        <div>
          <span class="search-heading">
            {{ "Search categories..." | translator }}
          </span>
        </div>
      </div>

      <!-- Query Builder Implementation -->

      <query-builder
        #queryBuilder
        *ngIf="
          !skelition && keyCount(queryBuilderConfig.fields).length > 0;
          else noFieldsTemplate
        "
        [persistValueOnFieldChange]="false"
        [(ngModel)]="query"
        [config]="queryBuilderConfig"
      >
        <!-- Add or remove rules controlls -->
        <ng-container
          *queryButtonGroup="
            let ruleset;
            let addRule = addRule;
            let addRuleSet = addRuleSet;
            let removeRuleSet = removeRuleSet
          "
        >
          <button class="v4-advance-border-btn" (click)="addRule()">
            <i class="mx-2 fa fa-plus"></i>معيار
          </button>
        </ng-container>

        <!-- Removing 'and' and 'or' buttons -->
        <ng-container *querySwitchGroup="let ruleset"> </ng-container>

        <!-- Changing remove rule button -->
        <ng-container
          *queryRemoveButton="let rule; let removeRule = removeRule"
        >
          <p-button
            icon="pi pi-times mt-2"
            styleClass="p-button-text p-button-danger"
            (onClick)="removeRule(rule)"
          >
          </p-button>
        </ng-container>

        <!-- Putting primeng dropdown in for fields -->
        <ng-container
          *queryField="let rule; let fields = fields; let onChange = onChange"
        >
          <p-dropdown
            [(ngModel)]="rule.field"
            (ngModelChange)="onChange($event, rule)"
            styleClass="col-md-3 col-12 my-1 mx-1"
            appendTo="body"
            [options]="fields"
            optionLabel="name"
            optionValue="name"
            placeholder="Select a Field"
            [filter]="true"
            filterBy="name"
          >
          </p-dropdown>
        </ng-container>

        <!-- Putting primeng dropdown in for condition -->
        <ng-container *queryOperator="let rule; let operators = operators">
          <p-dropdown
            [name]="rule.operator"
            [(ngModel)]="rule.operator"
            styleClass="col-md-3 col-12 mx-1 my-1"
            appendTo="body"
            [options]="operators"
            [filter]="true"
            filterBy="name"
            optionLabel="label"
            optionValue="value"
          >
          </p-dropdown>
        </ng-container>

        <!-- Putting primeng dropdown in for query input -->
        <ng-container *queryInput="let rule; type: 'string'">
          <input
            class="col-md-3 col-12 my-1 mx-1 ms-input-view"
            [(ngModel)]="rule.value"
            type="text"
            placeholder="البحث"
            pInputText
          />
        </ng-container>
      </query-builder>
      <!-- Template for empty fields type selection -->
      <ng-template #noFieldsTemplate>
        <span class="search-details">
          {{ "There are no ratings." | translator }}
        </span>
      </ng-template>

      <hr class="v4-border" />
      <!-- button section -->
      <div class="web-mob-flex w-100">
        <div class="w-100 d-flex flex-row justify-content-center">
          <button
            class="v4-advance-btn"
            [disabled]="checkDisabled()"
            (click)="submitFilter()"
          >
            {{ "advanced search" | translator }}
          </button>
        </div>
      </div>
      <!-- button section end -->
      <hr class="my-3 v4-border" />
    </div>
  </div>
</section>

<!-- advance search end -->
<p-messages [(value)]="messages" [enableService]="false"></p-messages>
<app-footer></app-footer>
